import type { z } from "zod";
import type { CreateFieldBodySchema } from "@/modules/forms/domain/contracts/forms";
import type { FormFieldType } from "@/server/platform/db/schema/forms";

export type CreateFieldPayload = z.infer<typeof CreateFieldBodySchema>;

const mkOpt = (value: string, label: string) => ({ value, label });

/** ຄ່າເບື້ອງຕົ້ນຜ່ານການກວດ API */
export function defaultCreateFieldInput(
  type: FormFieldType,
): CreateFieldPayload {
  switch (type) {
    case "section":
      return {
        type,
        label: "ພາກກຳນົດ",
        required: false,
        description: null,
        placeholder: null,
        options: undefined,
        settings: null,
      };
    case "text":
      return {
        type,
        label: "ຄຳຕອບສັ້ນ",
        required: false,
        description: null,
        placeholder: null,
        options: undefined,
        settings: null,
      };
    case "number":
      return {
        type,
        label: "ຕົວເລກ",
        required: false,
        description: null,
        placeholder: null,
        options: undefined,
        settings: null,
      };
    case "textarea":
      return {
        type,
        label: "ຄຳຕອບຍາວ",
        required: false,
        description: null,
        placeholder: null,
        options: undefined,
        settings: { rows: 4 },
      };
    case "choice":
      return {
        type,
        label: "ເລືອກຫນຶ່ງຄຳຕອບ",
        required: false,
        description: null,
        placeholder: null,
        options: [mkOpt("a", "ທາງເລືອກ 1"), mkOpt("b", "ທາງເລືອກ 2")],
        settings: null,
      };
    case "dropdown":
      return {
        type,
        label: "ລາຍການຫຼຸດລົງ",
        required: false,
        description: null,
        placeholder: null,
        options: [mkOpt("a", "ທາງເລືອກ 1"), mkOpt("b", "ທາງເລືອກ 2")],
        settings: null,
      };
    case "checkbox":
      return {
        type,
        label: "ເລືອກຫຼາຍຄຳຕອບ",
        required: false,
        description: null,
        placeholder: null,
        options: [mkOpt("a", "ທາງເລືອກ 1"), mkOpt("b", "ທາງເລືອກ 2")],
        settings: null,
      };
    case "date":
      return {
        type,
        label: "ວັນທີ",
        required: false,
        description: null,
        placeholder: null,
        options: undefined,
        settings: null,
      };
    case "datetime":
      return {
        type,
        label: "ວັນເວລາ",
        required: false,
        description: null,
        placeholder: null,
        options: undefined,
        settings: null,
      };
    case "file":
      return {
        type,
        label: "ແບປໄຟລ໌",
        required: false,
        description: null,
        placeholder: null,
        options: undefined,
        settings: null,
      };
    case "rating":
      return {
        type,
        label: "ໃຫ້ຄະແນນ",
        required: false,
        description: null,
        placeholder: null,
        options: undefined,
        settings: { maxRating: 5 },
      };
    case "repeater":
      return {
        type,
        label: "ລາຍການຊ້ຳ",
        required: false,
        description: null,
        placeholder: null,
        options: undefined,
        settings: {
          countMode: "dynamic",
          minItems: 1,
          maxItems: 10,
          allowAddRemove: true,
          showItemNumber: true,
          itemLabelTemplate: "ລາຍການ #{index}",
          itemFields: [
            { key: "name", label: "ຊື່", type: "text", required: true },
          ],
        },
      };
    default: {
      const _x: never = type;
      return _x;
    }
  }
}

export const FORM_FIELD_TYPE_LABEL_LA: Record<FormFieldType, string> = {
  section: "ພາກກຳນົດ",
  text: "ຂໍ້ຄວາມສັ້ນ",
  number: "ຕົວເລກ",
  textarea: "ຂໍ້ຄວາມຍາວ",
  choice: "ເລືອກຂໍ້ໜ້ຽງ",
  dropdown: "ດຮອບລາຍ",
  checkbox: "ເລືອກຫຼາຍ",
  date: "ວັນທີ",
  datetime: "ວັນເວລາ",
  file: "ໄຟລ໌",
  rating: "ຄະແນນ",
  repeater: "ລາຍການຊ້ຳ",
};
